export default function formatZipcode(zipCode) {
  const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/; // Pode usar ? no lugar do *

  if (re.test(zipCode)) {
    return zipCode.replace(re, '$1.$2-$3');
  }
  return '';
}
